import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ContactForm from '$partials/forms/contact-form';
import { Footer, Header, Meta } from '$partials/global';
import RichText from '$partials/global/rich-text';
import ModuleRelatedCarousel from '$partials/modules/individual/related-carousel';
import CodeSnippet from '$partials/global/code-snippet';
import { GlobalLayoutProvider, GlobalLayoutContext } from '$contexts/global-layout';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ContactSubPage = ({ data, domain }) => {
    const [stylingWhite, setStylingWhite] = useState(true);

    const page = data?.page;

    return (
        <>
            <Meta page={page} />

            <main
                id='main-content'>
                <div className='min-h-screen'>

                    <GlobalLayoutProvider>
                        <GlobalLayoutContext.Consumer>
                            {() => (
                                <Header
                                    menu={data?.navigation}
                                    setStylingWhite={setStylingWhite}
                                    stylingWhite={stylingWhite} />
                            )}
                        </GlobalLayoutContext.Consumer>
                    </GlobalLayoutProvider>

                    <div className='layout-container mt-90 md:mt-160'>

                        <article className='flex flex-col sm:flex-row md:justify-between'>
                            {/* Header */}
                            <header className='w-full sm:w-6/12 md:w-5/12 px-10 sm:px-5 md:px-10 mb-40'>
                                <h1 className='type-style-2 inline mr-10'>{page.title}</h1>

                                {page?.copy &&
                                    <div className='mt-20 md:mt-30'>
                                        <RichText
                                            className='rich-text'
                                            {...page.copy} />
                                    </div>
                                }
                            </header>

                            {/* Form */}
                            <section className='w-full sm:w-6/12 md:w-6/12 mb-40'>
                                {page.embedCode ? (
                                    <CodeSnippet html={page.embedCode} />
                                ) : (
                                    <ContactForm
                                        formConsentOptions={data.formConsentOptions}
                                        formEmail={page?.formEmailAddress}
                                        formFields={data.formFields}
                                        formId={data.formId}
                                        pageType={'bvaBusinessContactSubPageCollection'}
                                        slug={page.slug}
                                        title={page.title} />
                                )}
                            </section>
                        </article>
                    </div>
                    {data?.relatedArticles?.items?.length > 0 && (
                        <div className='mt-80 md:mt-115'>
                            <ModuleRelatedCarousel
                                items={data?.relatedArticles?.items}
                                title={data?.page?.relatedArticlesHeader} />
                        </div>
                    )}
                    <div className='pt-40 md:pt-60'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.object,
        footer: PropTypes.shape({
            items: PropTypes.array
        }),
        formFields: PropTypes.array,
        formId: PropTypes.string,
        formConsentOptions: PropTypes.object,
        navigation: PropTypes.object,
        showHideNewsletter: PropTypes.bool,
        relatedArticles: PropTypes.object,
    }),
    domain: PropTypes.string,
};

ContactSubPage.propTypes = propTypes;

export default ContactSubPage;
